import React from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import ActiveLink from './ActiveLink'

@inject("store")
@observer
export default class LayoutViewer extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    buttonBackgroundColor: PropTypes.string,
    buttonForegroundColor: PropTypes.string,
    textColor: PropTypes.string,
  }

  handleLayoutSelection = (layout) => {
    const { store } = this.props
    store.activeLayout = layout
  }

  render() {
    const { store, buttonBackgroundColor, buttonForegroundColor, textColor } = this.props
    const { designCategoryLayouts, activeLayout } = store
    const { primaryColor, contrastColor } = store.franchise.attributes

    const activeStyle = {
      backgroundColor: buttonBackgroundColor || primaryColor,
      color: buttonForegroundColor || contrastColor,
      ...styles.layout
    }
    const inactiveStyle = {
      backgroundColor: buttonForegroundColor || contrastColor,
      color: buttonBackgroundColor || primaryColor,
      ...styles.layout
    }

    return (
      <div style={styles.wrapper}>
        <div style={styles.container}>
          <ActiveLink
            show={!!activeLayout}
            onClick={() => this.handleLayoutSelection(null)}
            activeStyle={activeStyle}
            inactiveStyle={inactiveStyle}
          >
            All Layouts
          </ActiveLink>
        </div>
        { designCategoryLayouts.map(layout =>
          <div key={layout.id} style={styles.container}>
            <ActiveLink
              show={activeLayout !== layout}
              onClick={() => this.handleLayoutSelection(layout)}
              activeStyle={activeStyle}
              inactiveStyle={inactiveStyle}
            >
              { layout.attributes.name }
            </ActiveLink>
          </div>
        )}
      </div>
    )
  }
}

const styles = {
  wrapper: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 10
  },
  container: {
    padding: "2px 10px",
    marginBottom: 25
  },
  layout: {
    padding: 10,
    textDecoration: "none"
  }
}
